import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getUser } from '../service/authService';

const USER = getUser();
const ORGID = USER?.['custom:organizationId'];

// since we use React Router v6 and BrowserRouter, add Hotjar's SPA tracking inside a useEffect.
export default function HotjarTracker() {
  const location = useLocation();

  // Track only Vitro prod accounts
  useEffect(() => {
    if (window.hj && ORGID === '5' && process.env.REACT_APP_STAGE === 'prod') {
      window.hj('stateChange', location.pathname);
    }
  }, [location, ORGID]);

  return null;
}

const loadHotjar = (hjid, hjsv) => {
  window.hj =
    window.hj ||
    function hotjarFallback(...args) {
      (window.hj.q = window.hj.q || []).push(args);
    };

  window._hjSettings = { hjid, hjsv };
  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://static.hotjar.com/c/hotjar-${hjid}.js?sv=${hjsv}`;
  head.appendChild(script);
};

export function HotjarInit() {
  // Track only Vitro prod accounts
  useEffect(() => {
    if (ORGID === '5' && process.env.REACT_APP_STAGE === 'prod') {
      loadHotjar(6396746, 6);
    }
  }, [ORGID]);

  return null;
}

// This was the basic Hotjar setup which should be added in index.html, but since we now enable Hotjar only for specific orgs and environments, this approach is no longer used
//  Hotjar Tracking Code for Site 6396746
//  <script>
//   (function(h,o,t,j,a,r){
//       h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
//       h._hjSettings={hjid:6396746,hjsv:6};
//       a=o.getElementsByTagName('head')[0];
//       r=o.createElement('script');r.async=1;
//       r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
//       a.appendChild(r);
//   })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
// </script>
